import {
    EXECUTIVE_DASHBOARD_ACCESS_ROLES,
    EXECUTIVE_DASHBOARD_ROLES,
    isDeliveryCockpitEditionLimitedRole,
} from '../constants/deliveryCockpitNav';
import { isDeliveryCockpitRouteEdition } from '../constants/psaRouteEdition';

/**
 * Admin or Django superuser — full deferred route access on develop builds.
 *
 * @param {{ role?: string, is_superuser?: boolean }|null|undefined} user
 * @returns {boolean}
 */
export const hasDeferredRouteAdminAccess = (user) => (
    Boolean(user?.is_superuser) || user?.role === 'admin'
);

/**
 * Executive-tier roles that may open strategic KPI dashboards on develop builds.
 *
 * @param {{ role?: string }|null|undefined} user
 * @returns {boolean}
 */
export const hasExecutiveDashboardAccess = (user) => {
    if (hasDeferredRouteAdminAccess(user)) {
        return true;
    }
    return EXECUTIVE_DASHBOARD_ACCESS_ROLES.has(user?.role);
};

/**
 * Non-admin deferred modules (analytics, CRM, etc.) on develop builds.
 *
 * @param {{ role?: string, is_superuser?: boolean }|null|undefined} user
 * @returns {boolean}
 */
export const hasDeferredModuleAccess = (user) => {
    if (!isDeliveryCockpitRouteEdition()) {
        return false;
    }
    if (hasDeferredRouteAdminAccess(user)) {
        return true;
    }
    if (EXECUTIVE_DASHBOARD_ROLES.has(user?.role)) {
        return true;
    }
    return !isDeliveryCockpitEditionLimitedRole(user?.role);
};

/**
 * Public production builds: authenticated wedge personas see the edition guard;
 * anonymous and admin-tier users still get a generic 404.
 *
 * @param {{ role?: string, is_superuser?: boolean }|null|undefined} user
 * @returns {'not-found'|'edition-blocked'}
 */
export const getPublicEditionDeferredRouteMode = (user) => {
    if (!user || hasDeferredRouteAdminAccess(user)) {
        return 'not-found';
    }
    return 'edition-blocked';
};
